import {
  createClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { LocalToken, NewLocalToken, UpdateLocalToken } from './model';

const client = createClient('/rest/authorization/local/token');

export const localTokenPermissions = {
  SEARCH: 'cpms.search-local-tokens',
  GET: 'cpms.get-local-token',
  CREATE: 'cpms.create-local-token',
  UPDATE: 'cpms.update-local-token',
  DELETE: 'cpms.delete-local-token',
  BLOCK: 'cpms.block-local-token',
  UNBLOCK: 'cpms.unblock-local-token',
  VALIDATE: 'cpms.validate-local-token',
  INVALIDATE: 'cpms.invalidate-local-token'
};

export const searchLocalTokens: SearchOperation<LocalToken> = searchRequestFactory<LocalToken>(client, {
  pattern: '',
  permissionId: localTokenPermissions.SEARCH
});

export const getLocalToken: FindOperation<LocalToken, string> = getRequestFactory<LocalToken, string>(client, {
  permissionId: localTokenPermissions.GET
});

export const createLocalToken: SaveOperation<NewLocalToken> = postRequestFactory<NewLocalToken, LocalToken>(client, {
  pattern: '',
  permissionId: localTokenPermissions.CREATE
});

export const updateLocalToken: SaveOperation<UpdateLocalToken> = putRequestFactory<
  UpdateLocalToken,
  LocalToken,
  string
>(client, { pattern: '/{localTokenId}', permissionId: localTokenPermissions.UPDATE });

export const deleteLocalToken: DeleteOperation<void> = deleteRequestFactory<void, string>(client, {
  permissionId: localTokenPermissions.DELETE
});

// Actions

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface BlockLocalTokenCommand {}

export const block: SaveOperation<BlockLocalTokenCommand, void, string> = postRequestFactory<
  BlockLocalTokenCommand,
  void,
  string
>(client, {
  pattern: '/{localTokenId}/block',
  permissionId: localTokenPermissions.BLOCK
});

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UnblockLocalTokenCommand {}

export const unblock: SaveOperation<UnblockLocalTokenCommand, void, string> = postRequestFactory<
  UnblockLocalTokenCommand,
  void,
  string
>(client, {
  pattern: '/{localTokenId}/unblock',
  permissionId: localTokenPermissions.UNBLOCK
});

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ValidateLocalTokenCommand {}

export const validate: SaveOperation<ValidateLocalTokenCommand, void, string> = postRequestFactory<
  ValidateLocalTokenCommand,
  void,
  string
>(client, {
  pattern: '/{localTokenId}/validate',
  permissionId: localTokenPermissions.VALIDATE
});

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface InvalidateLocalTokenCommand {}

export const invalidate: SaveOperation<InvalidateLocalTokenCommand, void, string> = postRequestFactory<
  InvalidateLocalTokenCommand,
  void,
  string
>(client, {
  pattern: '/{localTokenId}/invalidate',
  permissionId: localTokenPermissions.INVALIDATE
});
